import { Outlet } from 'react-router-dom';
import { TestId } from '@repo/test-id';

import DashboardHeader from '@features/ownedParkingManage/components/dashboard/DashboardHeader';

export default function DashboardLayout() {
  const testId = TestId.root('parkingsDashboard');

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
        <DashboardHeader testId={testId.append('header')} />

        <div className="flex min-h-0 flex-1 p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
